<template>
  <CoreButton
    :disabled="isFetchingUserConfiguration"
    :label="t('login.messages.corporate_title', { corporate_title: 'SSO' })"
    :loading="isLoginButtonLoading"
    buttonType="secondary"
    class="tw-mx-auto tw-mt-4"
    dataTest="authorization-sso-login-button"
    type="submit"
    @click="login" />
</template>

<script setup lang="ts">
import CoreButton from 'frontcore/components/CoreButton.vue'
import i18n from 'frontcore/i18n'
import UseSSOLogin from 'frontcore/domain/authorization/view/UseSSOLogin'
import { AuthorizationSSOConfiguration } from 'frontcore/domain/authorization/model/types'
import { computed, watch } from 'vue'

type Props = {
  applicationId?: string
  configuration: AuthorizationSSOConfiguration
  isFetchingUserConfiguration: boolean
}
const props = defineProps<Props>()

type Emits = {
  (e: 'error', message: string): void,
  (e: 'loginSuccess'): void,
}
const emit = defineEmits<Emits>()

const { t } = i18n.global

const ssoLoginUseCase = new UseSSOLogin(props.configuration, emit, props.applicationId)
const { login, loading } = ssoLoginUseCase.use()

const isLoginButtonLoading = computed<boolean>(() => {
  return loading.value || (loading.value && props.isFetchingUserConfiguration)
})

watch(
  () => props.isFetchingUserConfiguration,
  (newValue, oldValue) => {
    if (newValue || newValue === oldValue) { return }
    loading.value = newValue
  }
)
</script>
